import { useDataProvider } from 'ra-core';
import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

export const CustomerNameWatcher = () => {
    const { setValue } = useFormContext();
    const customerId = useWatch({ name: 'customer_id' });
    const companyId = useWatch({ name: 'company_id' });
    const currentName = useWatch({ name: 'customer_name' });
    const dataProvider = useDataProvider();

    useEffect(() => {
        const fetchName = async () => {
            // Only auto-fill if the name is currently empty
            if (currentName) return;

            if (customerId) {
                try {
                    const { data: contact } = await dataProvider.getOne('contacts', { id: customerId });
                    if (contact) {
                        setValue('customer_name', `${contact.first_name} ${contact.last_name}`.trim(), { shouldDirty: true });
                        return;
                    }
                } catch (e) {
                    console.error('Error fetching contact name:', e);
                }
            }

            if (companyId) {
                try {
                    const { data: company } = await dataProvider.getOne('companies', { id: companyId });
                    if (company) {
                        setValue('customer_name', company.name, { shouldDirty: true });
                    }
                } catch (e) {
                    console.error('Error fetching company name:', e);
                }
            }
        };

        fetchName();
    }, [customerId, companyId, dataProvider, setValue]);

    return null;
};
